import { Outlet, useParams } from "@tanstack/react-router";
import { useSolution } from "@/hooks/use-solutions";
import { SolutionSidebar } from "./SolutionSidebar";
import { SolutionTopBar } from "./SolutionTopBar";

export function SolutionLayout() {
  const { solutionId } = useParams({ from: "/s/$solutionId" });
  const { data: solution } = useSolution(solutionId);

  return (
    <div className="min-h-screen flex bg-[var(--color-background)] text-foreground">
      <div className="print:hidden">
        <SolutionSidebar />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="print:hidden">
          <SolutionTopBar solutionName={solution?.name} />
        </div>
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
